// types
import type { ExtractedFact } from '@karehero/models';

// store
import { useGetCareCircleExtractedFactsQuery } from 'store/api/inference';

const NO_FACTS: ExtractedFact[] = [];

/**
 * useExtractedFacts returns what the AI read from the care circle's documents,
 * messages and voice notes. A failed load shows nothing.
 */
export const useExtractedFacts = (
  careCircleId: string | undefined,
): ExtractedFact[] => {
  const { data } = useGetCareCircleExtractedFactsQuery(
    { careCircleId: careCircleId ?? '' },
    { skip: !careCircleId },
  );
  return data?.facts ?? NO_FACTS;
};

/** Whether the facts have loaded, or failed to, so what they tick is known. */
export const useIsExtractedFactsLoaded = (
  careCircleId: string | undefined,
): boolean => {
  const { isSuccess, isError } = useGetCareCircleExtractedFactsQuery(
    { careCircleId: careCircleId ?? '' },
    { skip: !careCircleId },
  );
  return !careCircleId || isSuccess || isError;
};

/** When the facts were last fetched, so a reading can wait for them to be fetched again. */
export const useExtractedFactsFetchedAt = (
  careCircleId: string | undefined,
): number | undefined => {
  const { fulfilledTimeStamp } = useGetCareCircleExtractedFactsQuery(
    { careCircleId: careCircleId ?? '' },
    { skip: !careCircleId },
  );
  return fulfilledTimeStamp;
};
